import { Component, OnInit } from '@angular/core';

import { AppMemoryService } from '../../core/app-memory.service';
import { AuthService } from '../auth.service';
import { GetService } from '../../core/get.service';
import { Router } from '@angular/router';
import {environment} from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.less']
})
export class ForgotComponent implements OnInit {
  public serverError = null;
  public isRequestInProgress = false;
  public isRequestSuccess = false;

  public forgottenEmail = '';

  public languages = environment.languages || [];

  public selectedLang = environment.defaultLanguage;

  public translation = {};

  constructor(
    public router: Router,
    public authService: AuthService,
    public appMemory: AppMemoryService,
    public getService: GetService,
    public translate: TranslateService
  ) {
      if (!this.authService.isLocated) {
          this.router.navigateByUrl('/locate');
      }
      this.getTranslation();
  }

  sendForgot(forgotForm: any): void {
    this.isRequestSuccess = false;
    this.serverError = null;

    if (forgotForm.form.invalid) {
      return;
    }

    this.isRequestInProgress = true;
    this.getTranslation();
    this.getService.forgotPassword(this.forgottenEmail, this.selectedLang).then(
      (res: any) => {
        this.isRequestInProgress = false;

        if (res.status === 'ok') {
          this.isRequestSuccess = true;
        } else {
          this.serverError = [this.translation['noUserFoundWithSuchEmail']];
        }
      },
      (err: any) => {
        this.isRequestInProgress = false;

        if (err.status === 500) {
          this.serverError = [err.statusText];
          return;
        }
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  objectToArray(obj: Object) {
    return Object.keys(obj).map(key => obj[key]); // transorm Array-like Object to Array
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    this.selectedLang = lang;
  }

  ngOnInit() {}

  getTranslation() {
    this.translate.get('AUTH.noUserFoundWithSuchEmail').subscribe((word: string) => {
      this.translation['noUserFoundWithSuchEmail'] = word;
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/forgot/forgot.component.ts